import {
    AllFilter,
    AndFilter,
    ArrivalSpanFilter,
    EqualsFilter,
    InFilter,
    InScheduleFilter,
    MinimumTransitDurationFilter,
    NotEqualsFilter,
    OrFilter,
    PurchaseRuleFilterObject,
    PurchaseRuleFilterOperator,
    SameDayArrivalFilter,
    ValidationLevel,
} from "types";

export const createAndFilter = (values: Partial<AndFilter>): AndFilter => {
    return {
        object: "and_filter",
        operator: "and",
        filters: [],
        ...values,
    };
};

export const createOrFilter = (values: Partial<OrFilter>): OrFilter => {
    return {
        object: "or_filter",
        operator: "or",
        filters: [],
        ...values,
    };
};

export const createInScheduleFilter = (values: Partial<InScheduleFilter>): InScheduleFilter => {
    return {
        object: "in_schedule_filter",
        operator: "in_schedule",
        schedules: [],
        field: "currentTime",
        ...values,
    };
};

export const createInFilter = (values: Partial<InFilter>): InFilter => {
    return {
        object: PurchaseRuleFilterObject.IN_FILTER,
        operator: "in",
        operand: [],
        field: "",
        ...values,
    };
};

export const createAllFilter = (values: Partial<AllFilter>): AllFilter => {
    return {
        object: "all_filter",
        operator: "all",
        operand: [],
        field: "",
        ...values,
    };
};

export const createEqualsFilter = (operand: string, field: string, validationLevel?: ValidationLevel): EqualsFilter => {
    return {
        object: PurchaseRuleFilterObject.EQUALS_FILTER,
        field,
        operand,
        operator: PurchaseRuleFilterOperator.EQUALS,
        ...(validationLevel ? { validationLevel: validationLevel } : {}),
    };
};

export const createNotEqualsFilter = (
    operand: string,
    field: string,
    validationLevel?: ValidationLevel,
): NotEqualsFilter => {
    return {
        object: PurchaseRuleFilterObject.NOT_EQUALS_FILTER,
        field,
        operand,
        operator: PurchaseRuleFilterOperator.NOT_EQUALS,
        ...(validationLevel ? { validationLevel: validationLevel } : {}),
    };
};

export const createArrivalSpanFilter = (values: Partial<ArrivalSpanFilter>): ArrivalSpanFilter => {
    return {
        object: "arrival_span_filter",
        operator: "arrival_span",
        operand: 0,
        field: "arrivalDateTime",
        validationLevel: ValidationLevel.WARNING,
        ...values,
    };
};

export const createSameDayArrivalFilter = (values: Partial<SameDayArrivalFilter>): SameDayArrivalFilter => {
    return {
        object: "same_day_arrival_filter",
        operator: "same_day_arrival",
        field: "arrivalDateTime",
        validationLevel: ValidationLevel.WARNING,
        ...values,
    };
};

export const createMinimumTransitDurationFilter = (
    values: Partial<MinimumTransitDurationFilter>,
): MinimumTransitDurationFilter => {
    return {
        object: "minimum_transit_duration_filter",
        operand: 0,
        field: "arrivalDateTime",
        validationLevel: ValidationLevel.WARNING,
        ...values,
    };
};
